import React, { useState, useEffect } from 'react';
import Accordion, { AccordionItem } from '../../@base/Accordion';
import Input from '../../@base/Input';
import styles from '../../BotComponents/SharedStyle.module.css';
import { getParameter, Validation } from '../../BotComponents/Commons';
import Button from '../../@base/Button';

/** Detalha as configurações do Watson */
const DetailsConfigurations = (props) => {
  if (!props.component.parameters) return null;

  const parameterList = props.component.parameters;

  const [component, setComponent] = useState(props.component);
  const [inputValid, setInputValid] = useState({});

  const apiKey = getParameter(parameterList, 'watson.assistant.apikey');
  const instanceId = getParameter(parameterList, 'watson.assistant.id');
  const minimumConfidance = getParameter(parameterList, 'watson.minimumLevelConfidence');
  const apiUrl = getParameter(parameterList, 'watson.assistant.endpoint');
  const skillId = getParameter(parameterList, 'watson.skill.id');

  /** Atualiza um parametro do componente */
  const updateParameter = (parameterUpdated) => {
    const { parameters } = component;
    const parameterType = parameterUpdated.parameter.id;
    const parameterHaveToChangeId = parameters.findIndex((p) => p.parameter.id === parameterType);
    parameters[parameterHaveToChangeId] = parameterUpdated;
    setComponent({ ...component, parameters });
  };

  /** Salvas as configurações do componente do Watson */
  const saveConfigurations = () => {
    const minimumLevelConfidence = getParameter(component.parameters, 'watson.minimumLevelConfidence');

    if (minimumLevelConfidence.value > 1) minimumLevelConfidence.value = 1;
    else if (minimumLevelConfidence.value < 0) minimumLevelConfidence.value = 0;

    props.updateWatsonComponent(component.id, component);
  };

  /** Manipula a mudança de validação do parametro */
  const onValidHandler = (parameter) => (e) => {
    const changedParameter = parameter.parameter ? parameter.parameter.name : parameter;
    setInputValid((prev) => ({
      ...prev,
      [changedParameter]: e,
    }));
  };

  /** Manipula a mudança de valor do paraetro */
  const onChangeHandler = (e, parameter) => {
    const value = e.target.value / 100;
    updateParameter({
      ...parameter,
      value,
    });
  };

  /** Manipula a mudança de valor do paraetro */
  const onChangeNameHandler = (e) => {
    setComponent({ ...component, label: e.target.value });
  };

  /** Validador extra para nome */
  const setInvalidName = () => {
    if (props.component.labelFromBackend !== component.label.trim()
       && props.componentsListNames.includes(component.label.trim())) {
      return {
        valid: false,
        message: 'Esse nome já é utilizado em outro componente',
      };
    }
    return { valid: true };
  };

  /** Efeito executado depois que minimumConfidance é alterado */
  useEffect(() => {
    updateParameter(minimumConfidance);
  }, [minimumConfidance]);

  /** Efeito executado depois que  inputValid é alterado
   *  Altera o atributo isValid do componente que é usado para
   *  controlar a atualização do fluxo no contexto
   */
  useEffect(() => {
    const isValid = !Object.values(inputValid).includes(false);
    setComponent({ ...component, isValid });
  }, [inputValid]);

  return (
    <Accordion>
      <AccordionItem active>
        <div>Identificação da instância</div>
        <div className={styles.ComponentSubList} style={{ textAlign: 'left' }}>
          <div className="item-list">
            <div className="row">
              <Validation
                isValid={onValidHandler('name')}
                setInvalid={setInvalidName}
              >
                <Input
                  label="Nome"
                  labelWidth={190}
                  width={350}
                  inline
                  value={component.label}
                  onChange={onChangeNameHandler}
                  placeholder="Digite"
                  mandatory
                />
              </Validation>
            </div>
            <div />
          </div>
          <div className="item-list">
            <div className="row">
              <Validation isValid={onValidHandler('name')}>
                <Input
                  label="Nível de confiança mínimo (%)"
                  placeholder="Digite o Nível de confiança mínimo"
                  labelWidth={190}
                  width={350}
                  inline
                  number
                  min={0}
                  max={100}
                  value={(minimumConfidance.value * 100).toFixed(0)}
                  onChange={(e) => onChangeHandler(e, minimumConfidance)}
                  title={minimumConfidance.parameter.hint}
                  mandatory
                />
              </Validation>
            </div>

            <div />
          </div>
          <div className="item-list">
            <div className="row">
              <Input
                label="Chave da API"
                placeholder="Digite a chave da API"
                disabled
                value={apiKey.value}
                labelWidth={190}
                width={350}
                inline
              />
            </div>
            <div />
          </div>
          <div className="item-list">
            <div className="row">
              <Input
                label="Identificador da instância"
                placeholder="Digite o identificador da instância"
                disabled
                value={instanceId.value}
                labelWidth={190}
                width={350}
                inline
              />
            </div>
            <div />
          </div>
          <div className="item-list">
            <div className="row">
              <Input
                label="Identificador da skill padrão"
                placeholder="Digite o identificador da skill padrão"
                disabled
                value={skillId.value}
                labelWidth={190}
                width={350}
                inline
              />
            </div>
            <div />
          </div>
          <div className="item-list">
            <div className="row">
              <Input
                label="URL da API"
                placeholder="Digite a URL da API"
                disabled
                value={apiUrl.value}
                labelWidth={190}
                width={350}
                inline
              />
            </div>
            <div />
          </div>

          <div className="item-list mb-4">
            <div className="row">
              <div className="col-4" />
              <div className="col-7">
                <Button
                  classes="float-right"
                  primary
                  small
                  onClick={saveConfigurations}
                  disabled={Object.values(inputValid).includes(false)}
                >
                  <small>Salvar</small>
                </Button>
              </div>
            </div>
            <div />
          </div>

        </div>
      </AccordionItem>
      {/* <AccordionItem>
        <div>Como Funciona</div>
        <div>{ReactHtmlParser(props.component.description)}</div>
      </AccordionItem> */}
    </Accordion>
  );
};

export default DetailsConfigurations;
